/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../resources/datatypes';
import '../resources/enums';
import '../../resources/error';
import '../../common/sort';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "SearchCatalogItemVariationsRequest": {
                        "fields": {
                          "textFilter": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "categoryIds": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "stockLevels": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.StockLevel",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "enabledLocationIds": {
                            "type": "string",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "vendorIds": {
                            "type": "string",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "sort": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.Sort",
                            "id": 6,
                            "rule": "optional"
                          },
                          "nullFieldFilters": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.NullableField",
                            "id": 7,
                            "rule": "repeated"
                          },
                          "stockableFilter": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "soldOut": {
                            "type": "bool",
                            "id": 10,
                            "rule": "optional"
                          },
                          "customAttributeFilters": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CustomAttributeFilter",
                            "id": 11,
                            "rule": "repeated"
                          },
                          "trackInventoryLocationIds": {
                            "type": "string",
                            "id": 12,
                            "rule": "repeated"
                          },
                          "includeRelatedObjects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObjectType",
                            "id": 13,
                            "rule": "repeated"
                          },
                          "limit": {
                            "type": "int32",
                            "id": 14,
                            "rule": "optional"
                          },
                          "cursor": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          },
                          "inventoryCountsUnitTokenFilter": {
                            "type": "string",
                            "id": 16,
                            "rule": "repeated"
                          },
                          "archivedState": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.ArchivedState",
                            "id": 17,
                            "rule": "optional",
                            "options": {
                              "default": "ARCHIVED_STATE_NOT_ARCHIVED"
                            }
                          },
                          "includeInventoryCounts": {
                            "type": "bool",
                            "id": 18,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "sellable": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.SellableValue",
                            "id": 19,
                            "rule": "optional"
                          },
                          "stockable": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.StockableValue",
                            "id": 20,
                            "rule": "optional"
                          },
                          "followChildCategories": {
                            "type": "bool",
                            "id": 21,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      },
                      "SearchCatalogItemVariationsResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "itemVariations": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "relatedObjects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "inventoryCounts": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogItemVariationsResponse.LocationInventoryCount",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "cursor": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "LocationInventoryCount": {
                            "fields": {
                              "variationId": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "locationId": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "count": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "availableCount": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "committedCount": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "Sort": {
                        "fields": {
                          "field": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.Sort.SortField",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": "ITEM_NAME"
                            }
                          },
                          "order": {
                            "type": ".squareup.connect.v2.common.SortOrder",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": "ASC"
                            }
                          },
                          "locationId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "SortField": {
                            "values": {
                              "SORT_FIELD_DO_NOT_USE": 0,
                              "ITEM_NAME": 1,
                              "ITEM_VARIATION_INVENTORY_COUNT": 2,
                              "ITEM_VARIATION_PRICE": 3
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogItemVariationsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogItemVariationsResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogItemVariationsResponse?.nested?.LocationInventoryCount && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.Sort && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.Sort?.nested?.SortField) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Defines the request body for the [SearchCatalogItemVariations](api-endpoint:Catalog-SearchCatalogItemVariations) endpoint.
 * --
 *
 * SOURCE SearchCatalogItemVariationsRequest @ squareup/connect/v2/catalog/interfaces/search-catalog-item-variations.proto at 25:1
 */
export const SearchCatalogItemVariationsRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogItemVariationsRequest');
fixType(SearchCatalogItemVariationsRequest);
Builder.createAndAttachToType(SearchCatalogItemVariationsRequest);
/**
 * --
 * @desc Defines the response body returned from the [SearchCatalogItemVariations](api-endpoint:Catalog-SearchCatalogItemVariations) endpoint.
 * --
 *
 * SOURCE SearchCatalogItemVariationsResponse @ squareup/connect/v2/catalog/interfaces/search-catalog-item-variations.proto at 81:1
 */
export const SearchCatalogItemVariationsResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogItemVariationsResponse');
fixType(SearchCatalogItemVariationsResponse);
Builder.createAndAttachToType(SearchCatalogItemVariationsResponse);
/**
 * @desc Contains the inventory count for a specific variation at a specific location.
 *
 * SOURCE LocationInventoryCount @ squareup/connect/v2/catalog/interfaces/search-catalog-item-variations.proto at 87:3
 */
SearchCatalogItemVariationsResponse.LocationInventoryCount = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogItemVariationsResponse.LocationInventoryCount');
fixType(SearchCatalogItemVariationsResponse.LocationInventoryCount);
Builder.createAndAttachToType(SearchCatalogItemVariationsResponse.LocationInventoryCount);
/**
 * --
 * @desc Specifies how the variations returned by the search are sorted by designating a sort field and a sort order.
 * --
 *
 * SOURCE Sort @ squareup/connect/v2/catalog/interfaces/search-catalog-item-variations.proto at 114:1
 */
export const Sort = $root.lookupType('squareup.connect.v2.merchant_catalog.service.Sort');
fixType(Sort);
Builder.createAndAttachToType(Sort);
/**
 * @desc The field by which to sort the returned results.
 *
 * SOURCE SortField @ squareup/connect/v2/catalog/interfaces/search-catalog-item-variations.proto at 117:3
 */
Sort.SortField = $root.lookupEnum('squareup.connect.v2.merchant_catalog.service.Sort.SortField').values;